<template src="../templates/pagination.html" />

<script setup>

import {
    defineProps, defineEmits, toRefs, computed, nextTick,
} from 'vue';

const emit = defineEmits(['update:currentPage']);

const props = defineProps([
    // eslint-disable-next-line
    'currentPage',
    // eslint-disable-next-line
    'totalPages',
]);

const { totalPages, currentPage } = toRefs(props);

const isPaginated = computed(() => {

    return totalPages.value > 1;

});

// Function to scroll to the top of the element with ID 'blog-results-grid'
const scrollToResultsGrid = () => {

    const element = document.getElementById('blog-results-grid');

    if (element) {

        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - 16, behavior: 'smooth' });

    }

};

const prevPage = async() => {

    if (currentPage.value > 1) {

        currentPage.value -= 1;
        emit('update:currentPage', currentPage.value);
        await nextTick(); // Wait for the DOM to update
        scrollToResultsGrid(); // Call scroll function after updating the page

    }

};

const nextPage = async() => {

    if (currentPage.value < totalPages.value) {

        currentPage.value += 1;
        emit('update:currentPage', currentPage.value);
        await nextTick(); // Wait for the DOM to update
        scrollToResultsGrid(); // Call scroll function after updating the page

    }

};

// Compute the list of displayed page numbers with ellipsis
const displayedPages = computed(() => {

    const totalDisplayPages = 5; // Number of pages to display (including ellipsis)

    if (totalPages.value <= totalDisplayPages) {

        // If there are fewer pages than the display limit, show all pages
        return Array.from({ length: totalPages.value }, (_, index) => index + 1);

    }

    // Determine the current page's position in the pagination
    // eslint-disable-next-line
    const position = currentPage.value < 3 ? 'start' : (currentPage.value >= (totalPages.value - 2) ? 'end' : 'middle');

    switch (position) {

    case 'start':

        // Display pages 1 to (totalDisplayPages - 1), followed by ellipsis and the last page
        return [1, 2, 3, 4, '...', totalPages.value];

    case 'middle':

        // Display current page, one page before, one page after, ellipsis, and first/last pages
        return [
            1,
            '...',
            currentPage.value - 1,
            currentPage.value,
            currentPage.value + 1,
            '...',
            totalPages.value,
        ];

    case 'end':

        // Display the first page, ellipsis, and pages (totalPages.value - (totalDisplayPages - 1)) to totalPages.value
        return [1, '...', totalPages.value - 3, totalPages.value - 2, totalPages.value - 1, totalPages.value];

    default:

        return [];

    }

});

const gotoPage = async(pageNumber) => {

    if (pageNumber === '...') {

        return;

    }

    currentPage.value = pageNumber;
    emit('update:currentPage', pageNumber);
    await nextTick(); // Wait for the DOM to update
    scrollToResultsGrid(); // Call scroll function after updating the page

};

</script>
